import { Button } from '@/components/ui/button';
import { AuthLayout } from './AuthLayout';

/**
 * Écran d'un compte connecté sans rôle CRM (TICKET-SEC-07) : la base ne lui
 * donne accès à aucune donnée (00308), on l'explique au lieu d'afficher un
 * tableau de bord vide ou en erreur.
 */

interface NoCrmAccessProps {
  onSignOut: () => void;
}

export function NoCrmAccess({ onSignOut }: NoCrmAccessProps) {
  return (
    <AuthLayout
      title="Accès en attente"
      subtitle="Votre compte n'a pas encore accès au CRM. Demandez à un administrateur Désertours de vous attribuer un rôle, puis reconnectez-vous."
    >
      <Button type="button" variant="outline" className="w-full" onClick={onSignOut}>
        Se déconnecter
      </Button>
    </AuthLayout>
  );
}
